<template>
  <div>
    <div class="mainAdviceStyle">
      <div v-if="list.length > 0">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="item in list" :key="item.id"
            ><div
              style="display: flex; justify-content: space-between"
              @click="jumpInfo(item)"
            >
              <div>
                <div style="font-weight: 550; font-size: 16px">
                  {{ item.AdviceTitle }}
                </div>
                <div class="contentTimeClass">
                  {{ formatDate(item.SendTime) }}
                </div>
                <!-- <div class="contentClass">{{ item.AdviceContent }}</div> -->
              </div>
              <div>
                <van-button
                  :plain="item.CheckState == 0 ? true : false"
                  :style="{
                    color:
                      item.CheckState === 2
                        ? '#d6313f'
                        : 'rgba(70, 70, 70, 0.5)',
                    backgroundColor:
                      item.CheckState === 2
                        ? 'rgba(214, 49, 63, .1)'
                        : 'rgba(201, 201, 201, 0.5)',
                    'border-radius': '20px',
                  }"
                  size="small"
                  >{{
                    item.CheckState == 2 ? "已反馈  " : "未反馈"
                  }}</van-button
                >
              </div>
            </div>
          </van-cell>
        </van-list>
      </div>
      <div
        v-else
        style="
          width: 140px;
          position: absolute;
          left: 50%;
          margin-left: -70px;
          top: 30%;
        "
      >
        {{ " 暂无投诉建议信息 " }}
      </div>
    </div>

    <div style="width: 100%; position: absolute; bottom: 8%">
      <el-button
        type="primary"
        style="width: 92%; margin: 4% 1%; background: #fff; color: #409eff"
        plain
        @click="submit"
        >添 加</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "Advice",
  data () {
    return {
      list: [],
      loading: false,
      finished: false
    };
  },
  watch: {

  },
  created () {
    this.onLoad()
  },
  methods: {
    //时间戳转换方法    date:时间戳数字
    formatDate (date) {
      var date = new Date(date);
      var YY = date.getFullYear() + '-';
      var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
      var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
      return YY + MM + DD + " " + hh + mm + ss;
    },
    submit () {
      this.$router.push({ path: "/Advice" });
    },
    jumpInfo (row) {
      this.setAdviceID(row.AdviceID)
      this.$router.push({ path: "/AdviceInfo" });
    },
    onLoad () {
      this.loading = false
      this.apiGetAdviceListBySendOpenIDAPIGet({}, this, res => {
        if (res.code == 20000) {
          this.list = res.data
        } else {
          this.$toast(res.message);
        }
      });
    },
  }
};
</script>

<style scoped>
.mainAdviceStyle {
  /* height: 70vh; */
  position: relative;
  height: calc(100vh - 200px);
  overflow-y: auto;
}
.contentClass {
  font-size: 14px;
  color: rgb(117, 117, 117);
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏溢出的文本 */
  text-overflow: ellipsis; /* 使用省略号表示被隐藏的文本 */
  width: 75vw; /* 设置一个固定的宽度 */
  /* border: 1px red solid; */
}
.contentTimeClass {
  font-size: 12px;
  color: rgb(138, 138, 138);
}
</style>
